// removed by extract-text-webpack-plugin
module.exports = {"multiCtaWrapper":"multiCtaWrapper__uXaKn","bottom":"bottom__1dwlH","left":"left__3IQ2h","right":"right__37Gc5","vertical":"vertical__3e7ax","top":"top__6XUMV","center":"center__aSAL5","multiCtaPreview":"multiCtaPreview__3kULr","ctaBtnWrapper":"ctaBtnWrapper__ahjQ3","multiCtaBtn":"multiCtaBtn__1xLUc","playStore":"playStore__2BO6c","appStore":"appStore__3eCQD","appButtons":"appButtons__1aeaE"};


//////////////////
// WEBPACK FOOTER
// ./components/skinV3MultiCta/style.less
// module id = WSn2
// module chunks = 75